import Error from '../model/Error.js';
import Helper from '../accounting/Helper.js';
import axios from 'axios';

export default class OpenItemsExportRepository {

    static getCsvByClubIdAndQuery(clubId, query) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/invoices/open-items/export/csv${query}`, { responseType: 'blob' })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    const filename = new Helper().getFilenameFromHeaders(response['headers']);
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    resolve();
                })
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static getXlsxByClubIdAndQuery(clubId, query) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/invoices/open-items/export/xlsx${query}`, { responseType: 'blob' })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    const filename = new Helper().getFilenameFromHeaders(response['headers']);
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    resolve();
                })
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static getCsvByMemberIdAndQuery(memberId, query) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/members/${memberId}/invoices/open-items/export/csv${query}`, { responseType: 'blob' })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    const filename = new Helper().getFilenameFromHeaders(response['headers']);
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    resolve();
                })
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static getXlsxByMemberIdAndQuery(memberId, query) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/members/${memberId}/invoices/open-items/export/xlsx${query}`, { responseType: 'blob' })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    const filename = new Helper().getFilenameFromHeaders(response['headers']);
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    resolve();
                })
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

}
